var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 15.834H10.834C13.191 15.834 14.3695 15.834 15.1017 15.1017C15.834 14.3695 15.834 13.191 15.834 10.834V8.33398M15.834 8.33398C16.4175 8.33398 17.5077 9.9959 17.9173 10.4173M15.834 8.33398C15.2505 8.33398 14.1602 9.9959 13.7507 10.4173",
    stroke: "#3D424D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 5.83398V14.1673",
    stroke: "#3D424D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 5.83333C5.08714 5.83333 5.83333 5.08714 5.83333 4.16667C5.83333 3.24619 5.08714 2.5 4.16667 2.5C3.24619 2.5 2.5 3.24619 2.5 4.16667C2.5 5.08714 3.24619 5.83333 4.16667 5.83333Z",
    stroke: "#3D424D",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8327 5.83333C16.7532 5.83333 17.4993 5.08714 17.4993 4.16667C17.4993 3.24619 16.7532 2.5 15.8327 2.5C14.9122 2.5 14.166 3.24619 14.166 4.16667C14.166 5.08714 14.9122 5.83333 15.8327 5.83333Z",
    stroke: "#3D424D",
    strokeWidth: 1.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 17.4993C5.08714 17.4993 5.83333 16.7532 5.83333 15.8327C5.83333 14.9122 5.08714 14.166 4.16667 14.166C3.24619 14.166 2.5 14.9122 2.5 15.8327C2.5 16.7532 3.24619 17.4993 4.16667 17.4993Z",
    stroke: "#3D424D",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClasses);
export default __webpack_public_path__ + "static/media/classes.2c9b96d91c2c84f07625b86f065dbe26.svg";
export { ForwardRef as ReactComponent };